





















import { Component, Prop, Vue } from 'vue-property-decorator'
import questionIcon from '@/assets/img/icon/question.svg'

@Component
export default class InfoPopover extends Vue {
  @Prop({ type: Array, default: () => [] })
  lines!: string[]

  /** 单段文案；与 lines 二选一，优先 lines */
  @Prop({ type: String, default: '' })
  content!: string

  @Prop({ type: String, default: 'left' })
  placement!: string

  @Prop({ type: String, default: 'auto' })
  width!: string

  @Prop({ type: String, default: 'hover' })
  trigger!: string

  @Prop({ type: String, default: 'effective-time-popover' })
  popperClass!: string

  @Prop({ type: String, default: '' })
  iconSrc!: string

  @Prop({ type: String, default: '' })
  iconStyle!: string

  get displayLines(): string[] {
    if (this.lines && this.lines.length) {
      return this.lines;
    }
    return this.content ? [this.content] : [];
  }

  get finalIconSrc() {
    return this.iconSrc || questionIcon
  }
}
